<template>
  <v-layout align-center justify-center>
<!--    <v-card-text>-->
      <image-uploader
          id="fileUpload"
          :debug="0"
          :maxWidth="512"
          :quality="0.5"
          :autoRotate=false
          outputFormat="blob"
          :preview=false
          :className="['fileinput', { 'fileinput--loaded' : hasImage }]"
          :capture="false"
          accept="image/*"
          doNotResize="['gif', 'svg']"
          @input="setImage"
          hidden
      ></image-uploader>

    <div v-if="!image">
      <v-btn v-if="!buttonLabel" outlined @click="chooseFiles()"><v-icon class="blue--text">photo_camera</v-icon>Upload Image</v-btn>

      <v-btn v-if="buttonLabel" outlined :block="block" @click="chooseFiles()">
        <v-icon v-if="icon" class="blue--text">
          {{icon}}
        </v-icon>
        {{buttonLabel}}
      </v-btn>
    </div>

    <div v-if="progress">
        <div v-if="uploadStatus !== ''">{{uploadStatus}} {{progress}} %</div>
    </div>
<!--    </v-card-text>-->
    <v-card-actions v-if="image">
      <v-spacer></v-spacer>
      <v-btn @click="removeImage" text outlined class="error--text"><v-icon>delete</v-icon>delete</v-btn>
    </v-card-actions>

  </v-layout>
</template>
<script>
import { v1 as uuidv1 } from 'uuid';
import { ref, getStorage, deleteObject, uploadBytesResumable, getDownloadURL } from "firebase/storage";
export default {
  props: ['id', 'path', 'autoLoad', 'buttonLabel', 'block', 'icon'],
  data () {
    return {
      imageUrl: '',
      image: null,
      progress: undefined,
      uploadStatus: '',
      imageId: '',
    }
  },
  mounted() {
    if (this.autoLoad) {
      console.log(this.autoLoad)
      this.chooseFiles()
    }
  },
  computed: {
    user() {
      return this.$store.getters.user
    }
  },
  created () {
    console.log(this.buttonLabel)
  },
  methods: {
    chooseFiles () {
      //console.log("img upload invoked")
      document.getElementById("fileUpload").click()
    },
    hasImage (data) {
        console.log(data)
    },
    setImage (img) {
      this.image = img
      //console.log(img.type)
      this.uploadImage()
    },
    removeImage () {
      let userId = this.user.uid

      let storage = getStorage()
      let imgRef = ref(storage, '/' + this.path + '/' + userId + '/' + this.imageId)
      this.uploadStatus = ''
      deleteObject(imgRef).then(() => {
        return this.$emit('removeImage', true)
      })
          .then(() => {
            this.image = null
          })
          .catch((err) => {
        this.$store.dispatch('setError', err)
      });

    },
    uploadImage () {
      let file = this.image
      let imageId = uuidv1()
      this.imageId = imageId
      // console.log(imageId)
      let userId = this.user.uid
      let storage = this.$store.state.storage
      let imgRef = ref(storage, '/' + this.path + '/' + userId + '/' + this.imageId)
      // console.log(userId)
      const uploadTask = uploadBytesResumable(imgRef, file)
      return uploadTask.on('state_changed',
          (snapshot) => {
            // Observe state change events such as progress, pause, and resume
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            this.progress = progress
            // console.log('Upload is ' + progress + '% done');
            switch (snapshot.state) {
              case 'paused':
                this.uploadStatus = "Uploading paused"
                // console.log('Upload is paused');
                break;
              case 'running':
                this.uploadStatus = "Image Uploading"
                // console.log('Upload is running');
                break;
            }
          },
          (err) => {
            this.$store.dispatch('setError', err)
            console.log(err.message)
          },
          () => {
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
              //console.log('File available at', downloadURL);
              let imgLocation = '/'+ this.path + '/' + userId + '/' + this.imageId
              return this.$emit('imageLinkFound', {
                url: downloadURL,
                id: imageId,
                path: this.path,
                imgLocation: imgLocation
              })
            });
          }
      );
    },

  }
}
</script>
